import React, { Ref, forwardRef } from 'react';

import { StyleProp, Text, TextProps, TextStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

type Props = TextProps & {
    textKey: string | string[] | null;
    appendText?: null | string;
    appendTextStyle?: StyleProp<TextStyle>;
    testID?: string;
    accessible?: boolean;
    accessibilityLabel?: string;
};

const LocalizedText = forwardRef((props: Props, ref: Ref<Text>) => {
    const { t } = useTranslation();
    const {
        textKey,
        appendText,
        appendTextStyle,
        testID,
        accessibilityRole = 'text',
        ...restProps
    } = props;
    const keys = Array.isArray(textKey)
        ? textKey
        : (textKey && [textKey]) || [];
    const text = keys.map((key) => t(key, { defaultValue: key })).join(' ');

    return (
        <Text
            {...restProps}
            ref={ref}
            testID={testID}
            accessibilityRole={accessibilityRole}
        >
            {text}
            {appendText && <Text style={appendTextStyle}>{appendText}</Text>}
        </Text>
    );
});

export default LocalizedText;
